import { useEffect } from 'react';
import { requestFcmToken, refreshFcmToken } from '../firebase';
import api from '../services/api';

export function useFcm(userId?: number | null) {
  useEffect(() => {
    const run = async () => {
      if (!userId) return;
      const token = await requestFcmToken();
      if (token) {
        try {
          await api.post('/device-tokens', { device_token: token, platform: 'web' });
          console.log('✅ FCM device token registered:', token);
        } catch (error) {
          console.error('❌ Error registering device token:', error);
        }
      }
      // Note: onForegroundMessage listener is now in NotificationBell component
      // to avoid duplicate listeners
    };
    run();
  }, [userId]);
}

export async function refreshNotificationsToken(vapidKey?: string) {
  const token = await refreshFcmToken(vapidKey);
  if (!token) return false;
  try {
    await api.post('/device-tokens', { device_token: token, platform: 'web' });
    return true;
  } catch (e) {
    console.error('Failed to refresh and register FCM token', e);
    return false;
  }
}
